import { useDispatch, useSelector } from 'react-redux';
import {
  allInvitationGroupsSelector,
  invitationGroupsByHearingTypeIdSelector,
} from '../../../../../features/apiFeatures/invitationGroupSlice';
import { isAppReadySelector } from '../../../../../features/bootstrapSlice';
import {
  allHearingTypesSelector,
  isFetchingHearingTypesSelector,
} from '../../../../../features/apiFeatures/hearingTypeSlice';
import {
  getAllHearingTypesInitialize,
  getAllInvitationGroupsInitialize,
} from '../../../../../features/actions/api';
import { useEffect } from 'react';

export const useData = (selectedHearingTypeKey) => {
  const dispatch = useDispatch();

  const isAppReady = useSelector(isAppReadySelector);
  const allInvitationGroups = useSelector(allInvitationGroupsSelector);
  const invitationGroupsByHearingTypeId = useSelector(
    invitationGroupsByHearingTypeIdSelector(selectedHearingTypeKey),
  );
  const hearingTypes = useSelector(allHearingTypesSelector);
  const isFetchingHearingTypes = useSelector(isFetchingHearingTypesSelector);

  useEffect(() => {
    if (isAppReady) {
      dispatch(getAllHearingTypesInitialize());
      dispatch(getAllInvitationGroupsInitialize());
    }
  }, [dispatch, isAppReady]);

  return {
    allInvitationGroups,
    invitationGroupsByHearingTypeId,
    hearingTypes,
    isFetchingHearingTypes,
  };
};
